import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Actions from './actions';

/**
 * This action does nothing but pass the given payload to the success callback, as the old implementation of
 * this action was still showing a now obsolete add leave modal
 */
const update = action$ =>
    action$
        .ofType(Actions.update.type)
        .flatMap(({payload}) =>
            Observable.of(
                Actions.updateSuccess.action(
                    payload.personId,
                    payload.personType,
                    payload.startDate,
                    payload.endDate,
                    payload.leaveType,
                ),
            ),
        );

export default combineEpics(update);
